<template>
    <div>
        <div class="percentageCircleWrapper linkHover">
        <v-progress-circular class="percentageCircle" :value="value" :size="size" width="10" :color="color">
            <v-progress-circular class="percentageCircleBG" :value="value" :size="size" width="10" color="grey">
            </v-progress-circular>
            <span v-if="!hasIcon" class="synThickFont synLargeFont percentageRating">{{rating}}</span>
            <span v-if="hasIcon" class="synThickFont synLargeFont percentageRating"><v-icon color="white">mdi-pencil</v-icon></span>
        </v-progress-circular>
        </div>
        
    </div>
</template>
<script>
export default {
    name: "FeedbackPercentage",
    props: {
        rating: Number,
        color: String,
        size: String,
        hasIcon: Boolean
    },
    data() {
        return {
            interval: 0,
            value: 0,
        }
    },
    created() {
        // console.log('rating:',this.rating);
        this.interval = setInterval(() => {
            if (this.value === this.rating) {
            //   return (this.value = 0)
                return (this.value)
            } else if (this.value > this.rating){
                return (this.value)
            }
            this.value += 1
        }, 10)
    }
}
</script>
<style>
.percentageCircle{
    /* border-radius: 10px; */
    stroke-linecap: round;
}
.percentageCircleBG{
    /* stroke-linecap: round; */
    margin-top:28px !important;
    margin-left: 10px !important;
    
    opacity: 0.3;
    position: relative;
    /* background-color: blue; */
    z-index: -1;
}
.percentageCircleWrapper{
    position: relative;
    /* background: green; */
    z-index: 2;
}
.percentageRating{
    position: absolute;
}
</style>
